import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from '../copysource/format-read-settings/format-read-settings.util';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { IcebergSink } from 'app/model/pipeline/copysink/iceberg.sink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AzureBlobFSWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/azure-blob-fs-store-write-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(IcebergSink),
    asynchronous: true,
    adapts: {
        type: '*',
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class IcebergSinkAdapter extends CopySinkAdapter<IcebergSink, Model.IcebergSink> {
    protected override async _toResource(model: IcebergSink): Promise<Model.IcebergSink> {
        const result: Model.IcebergSink = {
            type: adfModelTypeMap.iceberg.copySinkType
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        await convertFormatSettingsToResource(model.formatSettings, result, this.context);

        if (model.storeSettings instanceof AzureBlobFSWriteSettings) {
            // only below 2 is supported in iceberg sink now
            result.storeSettings = {
                type: AzureBlobFSWriteSettings.MODEL.name,
                blockSizeInMB: result.storeSettings.blockSizeInMB,
                maxConcurrentConnections: result.storeSettings.maxConcurrentConnections,
            };
        }

        return result;
    }

    protected override async _toModel(resource: Model.IcebergSink, owner: Activity): Promise<IcebergSink> {
        const result = Owned.create<IcebergSink>(Metamodel.modelFor(IcebergSink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        await convertFormatSettingsToModel(resource.formatSettings, result, this.context);

        return result;
    }
}
